import React from "react"
// import clsx from "clsx"
// import CurrencyInput from "../CurrencyInput/CurrencyInput"
import { CardElement, } from '@stripe/react-stripe-js';

class PaymentGatewayTesterCreditCard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    }
    this.onToggleExpanded = this.onToggleExpanded.bind(this);
    this.updateCreditCard = this.updateCreditCard.bind(this);

  }

  render() {
    return(
      <div className="PaymentGatewayTesterCreditCard">
        <div className="row">
          <div className="col-md-7">
            <div className="form-group">
              <label style={{ marginBottom: '1rem' }}>{`${I18n.t('name_on_card')}`}</label>
              <input type='text' className='form-control' name='name_on_card' value={this.props.nameOnCard && this.props.nameOnCard ? this.props.nameOnCard : ''} onChange={this.props.onChangeNameOnCard} />
            </div>
          </div>
        </div>
        <div className="row"> 
          <div className="col-md-7">
            <div className="form-group">
              <label style={{ marginBottom: '1rem' }}>{`${I18n.t('test_card')}`} <span className="ss-help help" title={I18n.t('gateway_test_card_helper_text')}></span></label>
              <CardElement />          
            </div>
          </div>
        </div>
      </div>
    );
  };


  formatCurrency(num) {
    if (num && typeof num === 'number') {
      return (num / 100).toPrecision(4);
    }
  }

  updateCreditCard() {
    var card = {
      credit_card_first_name: this.refs.credit_card_first_name.value,
      credit_card_last_name: this.refs.credit_card_last_name.value,
      credit_card_number: this.refs.credit_card_number.value,
      credit_card_month: this.refs.credit_card_month.value,
      credit_card_year: this.refs.credit_card_year.value,
      credit_card_verification_value: this.refs.credit_card_verification_value.value,
      amount: this.refs.amount.getValue()
    };

    this.props.onUpdateCreditCard(card);
  }

  onToggleExpanded(event) {
    event.stopPropagation();
    event.preventDefault();

    this.setState({expanded: !this.state.expanded});
  }

};

export default PaymentGatewayTesterCreditCard
